/**
 * Register handlers for common events.
 */

import $ from 'jquery'
import { listenToToggleOffCanvas } from './common/off-canvas'
import {
  listenToHoverableCollapse,
  listenToToggleHorizontalMenu,
} from './common/hoverable-collapse'
import {
  listenToClickNavItem,
  listenToSwitchTheme,
  listenToMiscEvents,
  initializePerfectScrollbar,
} from './common/misc'
import { listenToSettingsEvents } from './common/settings'

/**
 * Register common events and initialize packages.
 */
function onReady() {
  listenToToggleOffCanvas()

  listenToHoverableCollapse()
  listenToToggleHorizontalMenu()

  // configureChart()
  listenToClickNavItem()
  listenToSwitchTheme()
  listenToMiscEvents()
  initializePerfectScrollbar()

  listenToSettingsEvents()
}

/**
 * Initialize the common module on document ready.
 */
function initialize() {
  $(onReady)
}

export { initialize }
